// extracted by mini-css-extract-plugin
export var standaloneTable = "_es-0";
export var standaloneTableWithBodyFill = "_es-1";
export var withExtraHeader = "_es-2";